function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "g10",
  transform: "matrix(1.3333333,0,0,-1.3333333,0,715.84)"
}, /*#__PURE__*/React.createElement("g", {
  id: "g12",
  transform: "scale(0.1)"
}, /*#__PURE__*/React.createElement("path", {
  id: "path14",
  className: "st0",
  d: "M893.3,4545.8l4.9,158.8l0.3,380L228.3,4547l-217-183.4l0.4,669.2l310.1,220.6l-110.1-230.3 l-0.2-345.7L895,5219.7l203.7,149l-0.4-660L893.3,4545.8"
}), /*#__PURE__*/React.createElement("path", {
  id: "path16",
  className: "st0",
  d: "M1973.9,4545.8l-4.9,158.8l-0.3,380l670.1-537.6l217-183.4l-0.4,669.2l-310.1,220.6l110.1-230.3 l0.2-345.7l-683.5,542.3l-203.6,149l0.4-660L1973.9,4545.8"
}), /*#__PURE__*/React.createElement("path", {
  id: "path18",
  className: "st0",
  d: "M2240.3,3453.6l-261.2-209.5l-0.9,255.3l243.3,195.3l158-123.4L2240.3,3453.6z M1570.2,2916 l0.2,123.2l-4.9,151l-131.9-104.9l-131.9,104.9l-4.9-151l0.3-123.2l-207.8,166.7l-0.3,430.1l-338,264.1l338,264.1l0.3,430.1 l207.8,166.6l-0.3-123.2l4.9-151l131.9,104.9l131.9-104.9l4.9,151l-0.2,123.2l207.8-166.6l0.3-430.1l338-264.1l-338-264.1 l-0.3-430.1L1570.2,2916z M487.7,3571.2l158,123.4L889,3499.3l-0.9-255.3l-261.2,209.5L487.7,3571.2z M487.7,3982.6l139.2,117.6 l261.2,209.5l0.9-255.3l-243.3-195.3L487.7,3982.6z M2379.5,3982.6l-158-123.4l-243.3,195.3l0.9,255.3l261.2-209.5L2379.5,3982.6z  M2715.3,3462.6l-391.4,314.2l391.4,314.2l148.1-69.8l3.8,342.3l-409.6-320.1l1,521.6l-307.6,255.9l107.7-250.3l-1.5-340.2 l-683.5,542.4l-140,116.5l-140-116.5l-683.5-542.4l-1.5,340.2l107.7,250.3l-307.6-255.9l1-521.6L0,4363.6l3.8-342.3l148.1,69.8 l391.4-314.2l-391.4-314.2L3.8,3532.4L0,3190.1l409.6,320.1l-1-521.6l307.6-255.9L608.6,2983l1.5,340.2l683.5-542.4l140-116.5 l140,116.5l683.5,542.4l1.5-340.2l-107.7-250.3l307.6,255.9l-1,521.6l409.6-320.1l-3.8,342.3L2715.3,3462.6"
}), /*#__PURE__*/React.createElement("path", {
  id: "path20",
  className: "st0",
  d: "M893.3,3008l4.9-158.8l0.2-380l-670.1,537.6l-217,183.4l0.4-669.2l310.1-220.6l-110.2,230.3 l-0.2,345.7L895,2334l203.7-149l-0.4,660L893.3,3008"
}), /*#__PURE__*/React.createElement("path", {
  id: "path22",
  className: "st0",
  d: "M1968.7,2469.1l0.3,380l4.9,158.8L1769,2845l-0.4-660l203.7,149l683.5,542.4l-0.2-345.7 l-110.1-230.3l310.1,220.6l0.4,669.2l-217-183.4L1968.7,2469.1"
}), /*#__PURE__*/React.createElement("path", {
  id: "path24",
  className: "st0",
  d: "M1159.1,3374.8h546.3l1,109.1l-24.8-26.6c-17.1-18.3-41.4-28.2-69.4-28.1l-238.9,1.3l175.1,194.8 l-90.2,81.6l-66-78L1159.1,3374.8"
}), /*#__PURE__*/React.createElement("path", {
  id: "path26",
  className: "st0",
  d: "M1379,3649.5l-220,192.3h546.7l0.6-113.4l-27.1,32.4c-15.4,18.4-38.3,28.3-65.2,28.2l-245.8-1.4 l74-66L1379,3649.5"
}), /*#__PURE__*/React.createElement("path", {
  id: "path28",
  className: "st0",
  d: "M1558.4,4255.1l37.5-66l2.3-204l-328.3,178l-108.8,63.7v-363.7h156.8l-40.1,37.7l0.7,185.7 l325.6-173.7l102.1-50.6v278.5c0,34.3-17.2,61.8-45.8,73.4L1558.4,4255.1"
})));

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 382.3 424.5",
    style: {
      enableBackground: "new 0 0 382.3 424.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6533b1f7.svg";
export { ForwardRef as ReactComponent };